import React from 'react';
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia, TextBox } from '../../components/imports';

const Content = () => {

  return (
    <ThisProject >
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent min-h-screen bg-black'>
          <ImageMedia src={require('./assets/SYCS_Logo_Black_Optimized_01.jpg')} />

          <div className='resp flex flex-col w-full paddingY'>
            <TextBox vertical title={"Architecture du Logo"} descr={<>Avec deux symboles essentiels à l&apos;assimilation rapide de l'identité par la cible du &quot;SYCS&quot;, nous avons recommandé la disposition ci-dessus en prime abord sur tous les supports officiels de communication. </>} />
            <ImageMedia src={require('./assets/DHIH9653.PNG')} className="mix-blend-screen= contrast-125 scaleOn oneSecond w-full" />
          </div>

          <ImageMedia src={require('./assets/IMG_0012.JPG')} />

          <div className='w-full flexV relative mx-auto *:w-full paddingY mt-10 gap-6'>
            <ImageMedia src={require('./assets/SYCS_Icons_2.png')} className="resp w-full !px-0" />


            <div className='grid grid-cols-2 w-full resp px-0 gap-6'>
              <MotionContent height={"h-[100%]"} translateRange={["0%", "-20%"]} className="">
                <ImageMedia src={require('./assets/HSOU0747.JPG')} className="relative md:landscape:scale-[110%] full object-contain object-center" />
              </MotionContent>
              <MotionContent height={"h-[100%]"} translateRange={["0%", "-20%"]} className="">
                <ImageMedia src={require('./assets/QZJV3219.JPG')} className="relative md:landscape:scale-[110%] full object-contain object-center" />
              </MotionContent>
            </div>
          </div>

          <MotionContent height={"h-[100%]"} translateRange={["40%", "-40%"]} className="">
            <ImageMedia src={require('./_cover.JPG')} />
          </MotionContent>
          <ImageMedia src={require('./assets/SYCS_Pattern_01.jpg')} />

        </div>
      )}
    </ThisProject>
  )
}

export default Content